module.exports = __webpack_public_path__ + "img/wave3.a5ee3f3.webp";